/* defaultLogger.js */

'use strict';
const CoreLogger = require('@gluenetworks/steve_core_logger');
module.exports = CoreLogger.getConsoleLogger(`forms_logger`);
